var PaymentMethod = /** @class */ (function () {
    function PaymentMethod(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        if (obj.active) {
            this.active = obj.active;
        }
        if (obj.online_payment) {
            this.online_payment = obj.online_payment;
        }
    }
    Object.defineProperty(PaymentMethod.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentMethod.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentMethod.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentMethod.prototype, "Active", {
        get: function () {
            return this.active;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentMethod.prototype, "OnlinePayment", {
        get: function () {
            return this.online_payment;
        },
        enumerable: false,
        configurable: true
    });
    return PaymentMethod;
}());
export { PaymentMethod };
export function createPaymentMethod(obj, id) {
    return new PaymentMethod(obj, id);
}
export function createPaymentMethods(rawMethods) {
    var methods = [];
    var rawMethodsData = rawMethods.data;
    for (var _i = 0, rawMethodsData_1 = rawMethodsData; _i < rawMethodsData_1.length; _i++) {
        var rawMethod = rawMethodsData_1[_i];
        var method = createPaymentMethod(rawMethod.attributes, rawMethod.id);
        methods.push(method);
    }
    return methods;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/paymentMethod/paymentMethod.ts
// module id = 123
// module chunks = 0